import React, { lazy } from 'react';
import styled from 'styled-components';
import { TextField as MuiTextField } from '@mui/material';
import { default as MuiAutocomplete } from '@mui/lab/Autocomplete';

const Autocomplete = (props) => {
  const {
    getOptionValue,
    getOptionLabel,
    renderOption,
    placeholder,
    multiple,
    onChange,
    options,
    value,
    ...rest
  } = props;

  return (
    <SAutocomplete
      multiple={multiple}
      id="size-small-outlined"
      size="small"
      options={options}
      getOptionLabel={getOptionLabel}
      renderOption={renderOption}
      getOptionSelected={(option, value) => option.id_ === value.id_}
      renderInput={({ ...params }) => (
        <TextField {...params} variant="outlined" placeholder={placeholder} />
      )}
      onChange={(event, value) => {
        return onChange(value);
      }}
      value={value}
      {...rest}
    />
  );
};

export default Autocomplete;

const SAutocomplete = styled(({ className, theme, ...props }) => {
  return (
    <MuiAutocomplete
      {...props}
      className={className}
      classes={{ option: className }}
    />
  );
})`
  &.MuiAutocomplete-option {
    margin: 5px 10px;
    border-radius: 18px;
  }

  &[aria-selected='true'] {
    background: ${({theme}) => theme.palette.primary.main};
  }

  .MuiAutocomplete-inputRoot {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    padding-left: 8px !important;
    border-color: ${({theme}) => theme.palette.colors.gray200};
  }
`;

//TODO refactor move to separate reusable component
const TextField = styled(({ theme, ...props }) => <MuiTextField {...props} />)`
  margin-bottom: ${(props) => props.mb || 0}px;
  width: 100%;

  .formControl {
    padding-top: ${(props) => props.multiline && '6px'};
    padding-bottom: ${(props) => props.multiline && '6px'};
    height: ${(props) => (props.multiline ? 'auto' : '32px')};
  }
  .input {
    height: ${(props) => (props.multiline ? 'auto' : '32px')};
    border-color: ${({theme}) => theme.palette.colors.gray200};
  }
  fieldset {
    transition: all 0.3s;
    border-color: ${({theme}) => theme.palette.colors.gray200};
  }
  .MuiInputAdornment-root {
    margin: 0 7px;
  }
`;
